<template lang="pug">
  a(:href="item.file" target="_blank").Paragraph.Paragraph-margin.ParagraphFile

    .ParagraphFile_wrapper(@click="toggle")
      .ParagraphFile_btn

        .ParagraphFile_ico.ParagraphFile_ico-download
          SvgInline(src="download")

      p.ParagraphFile_title {{item.title}}

</template>

<script>

import scrollUpdate from '@/mixins/scrollUpdate'
import SvgInline from '@/components/SvgInline'
import RadialProgress from '@/components/RadialProgress'
import {Howl, Howler} from 'howler'
import raf from 'raf'

export default {
  props: ['item'],
  mixins: [scrollUpdate],
  components: { SvgInline, RadialProgress },
  data () {
    return {

    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    toggle () {

    },
    onProgress (p, pv) {

    },
    onEnter () {
      this.$el.classList.add('is-visible')
    },
    onExit () {
      this.$el.classList.remove('is-visible')
    }
  }
}

</script>

<style lang="stylus">

.ParagraphFile
  width 100%
  padding 0 20px
  text-decoration none
  appearance none

  &_wrapper
    padding 30px
    width 100%
    max-width: 1100px
    position relative
    box-sizing border-box
    background-color $black
    text-align center
    display flex
    flex-direction row
    justify-content space-between
    align-items center
    color $beige
    cursor pointer

    @media $mq_m
      padding 40px 50px

    &:after
      border_distance = 10px
      content ''
      position absolute
      top border_distance
      left border_distance
      right border_distance
      bottom border_distance
      border 1px solid transparent
      transition all 0.8s 0.5s $ease

    &:hover
      .ParagraphFile_btn
        .RadialProgress
          color: transparent

      .ParagraphFile_ico
        background-color $beige
        color $black
        fill black

        svg, g, path

          fill black!important

        &-download
          fill black
          transform scale(1.1)

  &_btn
    position: relative
    opacity 0
    transition all 0.8s 0.5s $ease
    transform scale(0.3)

    .RadialProgress
      position: absolute
      top 50%
      left 50%
      transform translate(-50%,-50%)
      transition color 0.8s $ease

  &_ico
    width 60px
    height 60px
    border-radius 50%
    border 2px solid $beige
    display flex
    align-items center
    flex-direction column
    justify-content center
    color: $beige
    transition all 0.8s $ease

    svg
      width 18px
      position relative

  p
    flex-grow: 1
    font-size: 14px;
    line-height: 28px;
    letter-spacing 5px
    opacity 0
    margin auto
    transition all 0.8s 0.5s $ease
    margin-left 0px
    text-transform uppercase
    text-align: center;

    @media $mq_m
      font-size: 18px;
      line-height: 35px;

  &.is-visible

    .ParagraphFile_btn

      opacity 1
      transform scale(1)

    .ParagraphFile_wrapper:after

      border-color $beige

    p

      opacity 1
      letter-spacing 1px

</style>
